<template>
  <div class="lecturer-wtxh">
    <!-- 元宇宙筛选 -->
    <div class="filtrate">
      <div class="filtrate-content">
        <div class="filtrate-list listCont">
          <span class="filtrate-title">是否支持元宇宙跨空间培训: <a href="https://npx.kskstudy.com/activity/detail?id=32" target="_blank" rel="noopener noreferrer">
                  <img src="@/assets/tip_icon.png" alt="">
                </a></span>
          <span class="filtrate-option" :class="{'active': yyzIndex==1}" @click="changYyz('1')">是</span>
          <span class="filtrate-option" :class="{'active': yyzIndex==2}" @click="changYyz('2')">否</span>
        </div>
      </div>
    </div>
    <div class="lecturer-wtxh-content">
      <!-- 讲师列表 -->
      <ul class="teacher-grid" v-if="resultsList.data && resultsList.data.length">
        <li
          class="teacher-card"
          v-for="(item, idx) in resultsList.data"
          :key="item.id"
          :style="{'animation-delay': idx * 50 + 'ms'}"
          @animationend="onCardAnimated"
          @click="goHomePage(item)"
        >
          <div class="teacher-avatar">
            <img v-if="item.avatar" :src="item.avatar" />
            <img v-else src="@/assets/per_img.png" />
          </div>
          <div class="teacher-name-bar">
            <span>{{ item.name }}</span>
          </div>
        </li>
      </ul>
      <div class="empty-tip" v-else-if="loaded">暂无讲师数据</div>
      <pagination-wtxh v-if="num > 0" :num="num" :limit="limit" @getNew="getNew"></pagination-wtxh>
    </div>
    
  </div>
</template>

<script>
import PaginationWtxh from "@/components/pc/paginationWtxh.vue";

export default {
  name: "lecturerWtxh",
  components: {
    PaginationWtxh,
  },
  data() {
    return {
      resultsList: "",
      num: 0,
      limit: 8,
      nowPage: 1,
      loaded: false,
      yyzIndex: 1,
      siteInfo: "",
    };
  },
  mounted() {
    this.siteInfo = JSON.parse(localStorage.getItem("siteInfo"));
    this.getResultsList();
  },
  methods: {
    changYyz(num) {
      this.yyzIndex = num;
      this.getResultsList();
    },
    getResultsList() {
      if (this.yyzIndex == 2) {
        this.num = 0;
        this.resultsList = [];
        this.loaded = true;
        return;
      }
      this.$axios
        .post(`/v1/teacher/list`, {
          page: this.nowPage,
          pre_page: this.limit,
        })
        .then((res) => {
          this.num = res.data.total;
          this.resultsList = res.data;
          this.loaded = true;
        });
    },
    goHomePage(item) {
      this.$router.push("/lecturerHomepage/" + item.id);
    },
    onCardAnimated(e) {
      e.target.style.animation = 'none';
      e.target.style.opacity = '1';
    },
    getNew(nowPage) {
      this.nowPage = nowPage;
      this.getResultsList();
    },
  },
};
</script>

<style scoped lang="scss">
.lecturer-wtxh {
  background: #f7fbfc;
  min-height: 400px;
}
.lecturer-wtxh-content {
  width: 1192px;
  margin: 0 auto;
  padding: 75px 0 71px;
}
.teacher-grid {
  display: flex;
  flex-wrap: wrap;
  column-gap: 24px;
  row-gap: 28px;
  align-content: flex-start;
}
.teacher-card {
  width: 280px;
  overflow: hidden;
  cursor: pointer;
  opacity: 0;
  animation: cardFadeIn 0.4s ease forwards;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
  }
}
@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.teacher-avatar {
  width: 280px;
  height: 300px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.teacher-name-bar {
  width: 280px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0px 6px 12px 0px rgba(234, 234, 234, 0.6);
  font-size: 20px;
  font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
  font-weight: normal;
  color: rgba(62, 62, 62, 1);
  line-height: 28px;
  transition: background-color 0.3s, color 0.3s;
}
.teacher-card:hover .teacher-name-bar {
  background-color: rgba(55, 108, 236, 1);
  color: #fff;
}
.empty-tip {
  text-align: center;
  padding: 80px 0;
  font-size: 16px;
  color: #999;
}
.filtrate{
  padding: 20px 0 0;
  background-color: #fff;
}
.filtrate-list{
  align-items: flex-start;
  white-space: nowrap;
  height: 45px;
  overflow: hidden;
  img{
    width: 20px;
  }
}
.listCont{
  display: flex;
  align-items: flex-end;
  padding-top: 0 !important;
  padding-bottom: 30px;
  span{
    margin-bottom: 0 !important;
  }
}
.filtrate-option{
  margin-bottom: 10px;
}
</style>
